export const useLoadingStatus = (isLoading: boolean, hasOnceLoaded: boolean) => {
  return {
    isFirstLoad: isLoading && !hasOnceLoaded,
    isSubsequentLoad: isLoading && hasOnceLoaded,
  };
};
